import {
  HUBDATA_REFRESH,
  HUBDATA_FETCH,
  HUBDATA_GET_SUCCESS,
  HUBDATA_RESET
} from './actions';

const initialState = {
  fetchHubData: null,
  params: null
}

export function hubManagementReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case HUBDATA_REFRESH:
      return {
        ...state,
        params: data
      }

    case HUBDATA_FETCH:
      return {
        ...state,
        params: data
      }

    case HUBDATA_GET_SUCCESS:
      return {
        ...state,
        fetchHubData: data
      }

    case HUBDATA_RESET:
      return {
        fetchHubData: null,
        params: null
      }

    default:
      return state;
  }
}
